import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fd0e0b46&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=fd0e0b46&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0e0b46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd0e0b46')) {
      api.createRecord('fd0e0b46', component.options)
    } else {
      api.reload('fd0e0b46', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fd0e0b46&scoped=true", function () {
      api.rerender('fd0e0b46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hotel/comment/index.vue"
export default component.exports